<template>
  <div class="wrap">
    <div class="head flex-row text-left bg-white" style="border-bottom: 1px solid #D8D8D8;">
      <div class="flex1 store-msg text-nowrap ">
        <div class="text-nowrap font-1-1">{{name}}</div>
        <div class="text-nowrap font-0-6">地址:{{address}}</div>
      </div>
      <div class=" text-center mapshow font-0-8 bg-white" @click="bnGoMapClick(store)">
        <div>{{distance}}</div>
      </div>
    </div>
    <div class="content" id="baidumap">

    </div>
    <div class="footer flex-row color_white">
      <div class="flex1" @click="clickBack()">
        <img src="../../assets/image/back.svg" height="22px;"><br/>返回
      </div>
      <div class="flex3 text-center font-0-8">
        <div>你可以点击右上角“...”按键</div>
        <div>分享地址给朋友</div>
      </div>

    </div>
  </div>
</template>

<script>
  import ServiceUtils from "../../service/ServiceUtils";

  export default {
    name: "storeMap",
    data(){
      return{
        address: "",
        city: "",
        distance: "",
        name: "",
        sellerId: "",
        storeId: "",

      }
    },
    methods:{
      /**
       * 百度地图中寻找位置
       */
      findMap:function(){
        let div = document.getElementById('baidumap');
        let map = new BMap.Map(div);
        map.centerAndZoom(this.$route.params.city,11);
        let local = new BMap.LocalSearch(map, {renderOptions:{map: map}});
        map.enableScrollWheelZoom(true);
        map.enableDragging();
        local.search(this.$route.params.address);
      },
      /**
       * 点击返回按钮
       */
      clickBack:function () {
        let url = '/choose/{0}'.format(ServiceUtils.config.sellerId);
        this.$router.replace({path:url});
      },
    },

    mounted(){
      this.address = this.$route.params.address;
      this.city = this.$route.params.city;
      this.distance = this.$route.params.distance;
      this.name = this.$route.params.name;
      this.sellerId = this.$route.params.sellerId;
      this.storeId = this.$route.params.storeId;
      ServiceUtils.config.sellerId = this.$route.params.sellerId;
      ServiceUtils.config.storeId = this.$route.params.storeId;
      this.findMap();
    },
  }
</script>

<style scoped lang="scss">
  @import "../../assets/css/style";
  .content{
    position: absolute;
    top:60px;
    bottom: 55px;
    left:0;
    right: 0;
  }
  .footer{
    position: absolute;
    height: 55px;
    bottom: 0;
    left:0;
    right: 0;
    background: rgba(0,0,0,.8);
  }
  .head{
    position: absolute;
    height: 60px;
    top: 0;
    left:0;
    right: 0;
  }
  .store-msg{
    padding: 15px 10px;
    border-right: 1px solid #D8D8D8;
  }
  .mapshow{
    width: 110px;
  }
</style>



// WEBPACK FOOTER //
// src/components/routerPages/storeMap.vue